import { apiFetch } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";
import type { PageResponse } from "@/features/product/types";
import {
  normalizeProduct,
  normalizeProductPage,
  type ProductPageResponse,
  type ProductResponse,
} from "@/features/product/normalization";
import type {
  SupplierCatalogAssociatePayload,
  SupplierCatalogPageQuery,
  SupplierCatalogProduct,
} from "./types";

export function listSupplierCatalogProducts(
  limit = 2000,
  offset = 0,
): Promise<PageResponse<SupplierCatalogProduct>> {
  return apiFetch<ProductPageResponse>(
    `${ENDPOINTS.supplierCatalog.list}?limit=${limit}&offset=${offset}`,
  ).then(normalizeProductPage);
}

export function listSupplierCatalogPage(
  query: SupplierCatalogPageQuery,
  signal?: AbortSignal,
): Promise<PageResponse<SupplierCatalogProduct>> {
  const params = new URLSearchParams({
    limit: String(query.limit),
    offset: String(query.offset),
    mode: query.mode,
  });
  const search = query.search.trim();
  if (search) params.set("search", search);
  if (query.category) params.set("category", query.category);

  return apiFetch<ProductPageResponse>(
    `${ENDPOINTS.supplierCatalog.list}?${params}`,
    { signal },
  ).then(normalizeProductPage);
}

export function associateSupplierCatalogProduct(
  payload: SupplierCatalogAssociatePayload,
): Promise<SupplierCatalogProduct> {
  return apiFetch<ProductResponse>(ENDPOINTS.supplierCatalog.list, {
    method: "POST",
    body: JSON.stringify(payload),
  }).then(normalizeProduct);
}

export function removeSupplierCatalogProduct(productId: string): Promise<void> {
  return apiFetch(ENDPOINTS.supplierCatalog.detail(productId), {
    method: "DELETE",
  });
}
